<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="outStockBills"
        @addOrEdit="addEditHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @delete="deleteHandle">
      <template slot="otherBtn">
        <el-button v-if="limits.exportAuth" type="primary" :loading="exportLoading" @click="exportHandle">导出</el-button>
        <el-button v-if="limits.subAuth" type="primary" :disabled="!selection.length" @click="submitHandle">
          提交
        </el-button>
        <el-button v-if="limits.cancelAuth" type="primary" :disabled="!selection.length" @click="cancelHandle">
          撤销
        </el-button>
        <el-button v-if="limits.printAuth" type="primary" :disabled="!selection.length" @click="printHandle">
          打印出库单
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.postAuth" type="success" :disabled="scope.row.statusName==='全部出库' || scope.row.statusName==='未提交'" @click="postToSap(scope.row)">过账</el-button>
        <!--        <el-button v-if="limits.postAuth" type="success" :disabled="scope.row.statusName==='已出库'" @click="postToSap(scope.row)">过账</el-button>-->
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="出库单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入出库单号" clearable/>
          </el-form-item>
          <el-form-item label="出库类型">
            <el-select v-model="filter.outStockType" placeholder="请选择出库类型" clearable>
              <el-option label="生产领料" :value="2"/>
              <el-option label="委外发料" :value="4"/>
              <el-option label="超领出库" :value="11"/>
              <el-option label="客供退料" :value="13"/>
              <el-option label="供应商退货_送货单(当月)" :value="14"/>
              <el-option label="供应商退货_退货单(跨月)" :value="15"/>
            </el-select>
          </el-form-item>
          <el-form-item label="出库状态">
            <el-select v-model="filter.status" placeholder="请选择出库状态" clearable>
              <el-option label="未提交" :value="0"/>
              <el-option label="已提交" :value="1"/>
              <el-option label="已出库" :value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单据编号" clearable/>
          </el-form-item>
          <el-form-item label="出库日期">
            <el-date-picker
                v-model="outStorageDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="outStorageDateChange"
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="createDateChange"
            />
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <!-- 出库单详情 -->
    <out-stock-order-detail ref="outStockOrderDetail" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import OutStockOrderDetail from "./OutStockOrderDetail";

  export default {
    name: "OutStockOrder",
    components: {viewTable, OutStockOrderDetail},
    data() {
      return {
        limits: {
          addAuth: this.$auth(525),
          editAuth: this.$auth(526),
          printAuth: this.$auth(531),
          delAuth: this.$auth(528),
          cancelAuth: this.$auth(530),
          subAuth: this.$auth(529),
          postAuth: this.$auth(527),
          exportAuth:this.$auth(66),
        },
        filter: {
          billNo: "",
          outStockType: "",
          relBillNo: "",
          status: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            width: 140,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.outStockOrderDetail.open(params.row, true,false);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "outStockTypeName",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "relBillNo",
            width: 160,
            align: "center",
          },
          {
            tooltip: true,
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "requireDate",
            width: 180,
            align: "center",
          },
          {
            tooltip: true,
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "operatorName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "createTime",
            width: 180,
            align: "center",
          },
          {
            tooltip: true,
            key: "postTime",
            width: 180,
            align: "center",
          },
          {
            tooltip: true,
            key: "note",
            minWidth: 150,
          },
          {
            key: "action",
            align: "center",
            width: 220,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
        outStorageDate: "", // 出库日期
        createDate: "", // 制单日期
        exportLoading: false,
      };
    },
    methods: {
      // 查询出库单列表
      loadData(pageNum) {
        this.selection = [];
        this.$refs.viewTable.loadData(pageNum);
      },

      otherAuth: (row) => {
        return !!row.status;
      },

      addEditHandle(row) {
        this.$refs.outStockOrderDetail.open(row);
      },

      // 删除 (只能删除未提交的出库单)
      deleteHandle(row) {
        if (row.status !== 0) {
          this.$confirm("只能删除未提交的出库单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$http.delete("basic", "outStockBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      },

      // 提交
      submitHandle() {
        let arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交的出库单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定提交吗?", "提示", {type: "warning"})
            .then(() => {
              let ids = [];
              this.selection.forEach((item) => {
                ids.push(item.pkid);
              });
              this.$http.post("basic", "outStockBills/submit", ids).then((res) => {
                if (res.success) {
                  this.loadData(1);
                  this.$message.success("提交成功");
                }
              });
            })
            .catch(() => {
            });
        }
      },

      // 撤销
      cancelHandle() {
        this.$confirm("确定撤销吗?", "提示", {type: "warning"})
          .then(() => {
            let ids = [];
            this.selection.forEach((item) => {
              ids.push(item.pkid);
            });
            this.$http.post("basic", "outStockBills/cancel", ids).then((res) => {
              if (res.success) {
                this.loadData(1);
                this.$message.success("撤销成功");
              }
            });
          })
          .catch(() => {
          });

      },

      selectHandle(selection) {
        this.selection = selection;
      },

      outStorageDateChange(date) {
        if (date) {
          this.filter.requireDateBegin = date[0];
          this.filter.requireDateEnd = date[1];
        } else {
          this.filter.requireDateBegin = "";
          this.filter.requireDateEnd = "";
        }
      },

      createDateChange(date) {
        if (date) {
          this.filter.createTimeBegin = date[0];
          this.filter.createTimeEnd = date[1];
        } else {
          this.filter.createTimeBegin = "";
          this.filter.createTimeEnd = "";
        }
      },

      // 重置
      resetHandle(filter) {
        this.createDate = "";
        this.outStorageDate = "";
        this.filter = Object.assign(this.filter, filter);
      },

      // 打印
      printHandle() {
        // 检查选中的出库单中是否包含委外出库(4)且非全部为委外出库
        const hasOutsource = this.selection.some(item => item.outStockType === 4);
        const allOutsource = this.selection.every(item => item.outStockType === 4);
        
        if (hasOutsource && !allOutsource) {
          this.$message.warning("出类型中包含委外出库，请重新勾选");
          return;
        }
        
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.upDataPrintStatus(ids);
        const routeUrl = this.$router.resolve({
          path: "/outboundOrderPrint",
          query: {
            params: ids,
            outStockType: this.selection[0].outStockType,
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      upDataPrintStatus(ids) {
        this.$http.post("basic", "outStockBills/print",ids).then((resp) => {
          if (resp.success) {
            this.$message.success("打印状态修改成功");
          }else {
            this.$message.error("打印状态修改失败");
          }
        }).catch(() => {
          this.$message.error("打印状态修改失败");
        });
      },
      postToSap(row) {
        this.$refs.outStockOrderDetail.open(row, null, true);
        // this.$http.get("basic", `outStockBills/postToSap/${row.pkid}`).then((res) => {
        //   if (res.success) {
        //     this.loadData(1);
        //     this.$message.success("过账成功");
        //   }
        // });
      },
      // 导出处理
      exportHandle() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        this.$http.exportExcel("basic", "outStockBills/export", params)
          .then((res) => {
            // const blob = new Blob([res.data]);
            // const downloadElement = document.createElement("a");
            // const href = window.URL.createObjectURL(blob);
            // const contentDisposition = res.headers["content-disposition"];
            // let fileName = "导出数据";
            // if (contentDisposition) {
            //   fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
            // }
            // downloadElement.style.display = "none";
            // downloadElement.href = href;
            // downloadElement.download = fileName + ".xls"; // 下载后文件名
            // document.body.appendChild(downloadElement);
            // downloadElement.click(); // 点击下载
            // document.body.removeChild(downloadElement); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放掉blob对象
            // 创建Blob对象
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);

            // 设置下载文件名
            const fileName = `出库单明细数据_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$message.success("导出成功");
          })
          .catch(() => {
            this.exportLoading = false;
            this.$message.error("导出失败");
          })
          .finally(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
